import Endpoint from "@/enums/Endpoint"
import { captureWarning, captureError } from "@/sentry"

// 401s recover via the wrong-password and session-expired flows — not reported
const UNREPORTED_STATUS_CODES = new Set<number>([401])

// Failed logins and booking mutations block the user outright
const ERROR_LEVEL_ENDPOINTS: Endpoint[] = [Endpoint.LOGIN, Endpoint.CREATE_BOOKING, Endpoint.CANCEL_BOOKING]

// One event per endpoint+status per interval — keeps the signal, avoids storms
const CAPTURE_INTERVAL_MS = 5 * 60 * 1000
const lastCapturedAt = new Map<string, number>()

export function reportApiError(endpoint: Endpoint, statusCode: number, responseBody?: string): void {
  if (UNREPORTED_STATUS_CODES.has(statusCode)) return

  const key = `${endpoint}:${statusCode}`
  const now = Date.now()
  const previous = lastCapturedAt.get(key) ?? 0
  if (now - previous < CAPTURE_INTERVAL_MS) return
  lastCapturedAt.set(key, now)

  const capture = ERROR_LEVEL_ENDPOINTS.includes(endpoint) ? captureError : captureWarning
  capture(`API error: ${endpoint} (${statusCode})`, {
    tags: { endpoint, api_status_code: String(statusCode) },
    extra: { responseBody },
    fingerprint: [endpoint, String(statusCode)]
  })
}
